import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken} from '../../storage'
import SearchInput from '../search/search'


export default class UnitList extends React.Component {


  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateUnit = this.goToCreateUnit.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    document.title = "Unit List"
  }

  goToCreateUnit(e) {
    e.preventDefault()
    this.props.history.push("/units/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/units/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  handleSearchInput(q) {
    this.fetchData(this.state.tableState, null, q)
  }



    fetchData(state, instance, query=this.state.query) {
      this.setState({ loading: true });
      let apiurl = "/list_units/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }

      if(query) {
        apiurl = apiurl + "&q="+query
      }

      this.setState({tableState:state, query:query})

      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.units,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {
      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'Primary Unit', accessor: 'primary_unit',sortable:true },
        {Header:'Container Unit',  accessor:'container_unit',sortable:true},
        {Header:'Container Volume',  accessor:'container_volume',sortable:true},
      ]
      const defaultSort=[{id: "id", desc: true}]
      return <div><section className="medium">
      <div className="row">
      <div className="col-md-3">
      <button onClick={this.goToCreateUnit} className="btn btn-primary">Create New Unit</button>
      </div>
      <div className="col-md-3 mtop">
        <SearchInput handleSearchInput={this.handleSearchInput} placeholder={"Search Units"} />
      </div>
      </div>

      </section>
      <div className="row mbottom ">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Units Found."
                columns={columns} manual data={data} showPagination={false}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/unit/unitlist.js